
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    constructor(private toastr: ToastrService) {}

    setMessage(code: number, message: any, title?: string) {
        switch (code) {
            case 100: {
                this.toastr.success(message, title);
                break;
            }
            case 1200:
            case 102: {
                this.toastr.info(message, title);
                break;
            }
            case 104: {
                this.toastr.warning(message, title);
                break;
            }
            default: {
                this.toastr.error(message, title);
                break;
            }
        }
    }
}
